import React from "react";
import { object, array, number, string } from "prop-types";
import { format } from "date-fns";
import { kn } from "date-fns/locale";
import { Link } from "@quintype/components";
import CardImage from "../../atoms/cardimage";
import Headline from "../../atoms/headline";

import "./story-card6.m.css";

const StoryCard6 = ({ story, aspectRatio, imageType, headerType, headerLevel }) => {
  const publishedDate = format(new Date(story["first-published-at"]), "d MMMM yyyy, H:mm", { locale: kn }).replace(
    "ಫೆಬ್ರವರಿ",
    "ಫೆಬ್ರುವರಿ"
  );

  return (
    <div className="story-card story-card-6" styleName="story-card-6">
      <Link href={`/${story.slug}`}>
        <div styleName="card-wrapper">
          <Headline text={story.headline} headerType={headerType} headerLevel={headerLevel} story={story} />

          <CardImage story={story} aspectRatio={aspectRatio} imageType={imageType} widths={[128]} showVideoIcon />
        </div>
      </Link>
      <div styleName="timestamp">
        <div styleName="date">{publishedDate} IST</div>
      </div>
    </div>
  );
};

StoryCard6.defaultProps = {
  aspectRatio: [16, 9],
  imageType: "image16x9",
  headerType: 2,
  headerLevel: 2
};

StoryCard6.propTypes = {
  story: object.isRequired,
  aspectRatio: array,
  imageType: string,
  headerType: number,
  headerLevel: number
};

export default StoryCard6;
